import React from 'react';
import { useSelector } from 'react-redux';

import {
  scheduleErrorsSelector,
  useGetLibraryQuery,
} from 'features/classCreation';
import ClassesScheduleSelect from '../ClassesScheduleSelect';
import ErrorLayout from 'components/ErrorLayout';
import Field from 'components/Field';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import ScheduleButton from '../ScheduleButton';
import ScheduleLibraryClassesTable from '../ScheduleLibraryClassesTable';
import ScheduleStartDateInput from '../ScheduleStartDateInput';
import styles from './LibraryAndScheduleSection.module.scss';

function LibraryAndScheduleSection({ libraryId }) {
  const { isLoading, isFetching, error, data, refetch } =
    useGetLibraryQuery(libraryId);

  const errors = useSelector(scheduleErrorsSelector);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load library"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const library = data?.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Field
          clientErrors={errors}
          label="Lectures"
          name="library_classes"
        >
          <ScheduleLibraryClassesTable
            classes={library.library_academy_topics}
          />
        </Field>
        <Field
          clientErrors={errors}
          label="Schedule"
          name="schedule"
        >
          <div className={styles.scheduleFieldGroup}>
            <ClassesScheduleSelect />
            <ScheduleStartDateInput />
          </div>
        </Field>
        <ScheduleButton />
      </>
    );
  } else {
    return null;
  }
}

export default LibraryAndScheduleSection;
